import React from "react";
import { FEATURED, SYSTEMS } from "../data";

export default function Systems() {
  return (
    <section id="systems">
      <div className="section-head">
        <div className="label">§05 · projects</div>
        <div className="h">Selected work</div>
        <div className="meta"></div>
      </div>

      {/* Featured */}
      <a href={FEATURED.url} target="_blank" rel="noreferrer" className="featured">
        <div className="featured-grid">
          <div className="featured-left">
            <div className="featured-stamp">
              <span className="stamp-ring">●</span>
              <span>2ND PLACE · GPT-5 HACKATHON 2025</span>
            </div>
            <div className="featured-name">
              <span className="path-prefix">~/projects/</span>
              {FEATURED.nm}
            </div>
            <div className="featured-tagline">{FEATURED.tagline}</div>
            <div className="featured-desc">{FEATURED.desc}</div>
            <div className="featured-tags">
              {FEATURED.tags.map((t) => (
                <span className="tag-sm" key={t}>{t}</span>
              ))}
            </div>
          </div>
          <div className="featured-right">
            <div className="featured-team">
              team · <b>{FEATURED.team}</b>
            </div>
            <div className="featured-metrics">
              {FEATURED.metrics.map((m) => (
                <div className="m" key={m.l}>
                  <div className="v">{m.v}</div>
                  <div className="l">{m.l}</div>
                </div>
              ))}
            </div>
            <div className="featured-cta">
              view writeup <span>↗</span>
              <span className="sr-only"> (opens in new tab)</span>
            </div>
          </div>
        </div>
      </a>

      {/* Repo grid */}
      <div className="systems">
        {SYSTEMS.map((s) => (
          <a key={s.url} href={s.url} target="_blank" rel="noreferrer" className="system">
            <div className="top">
              <div className="nm">
                <span>{s.nm}</span>
              </div>
              <span className={"badge" + (s.badge.w ? " warn" : "")}>
                ● {s.badge.t}
              </span>
            </div>
            <div className="desc">{s.desc}</div>
            <div className="tags">
              {s.tags.map((t) => (
                <span className="tag-sm" key={t}>{t}</span>
              ))}
            </div>
            <span className="sr-only">(opens in new tab)</span>
          </a>
        ))}
      </div>
    </section>
  );
}
